<script setup>
definePageMeta({
  middleware: ['not-authenticated'],
})
</script>

<template>
  <div class="min-h-area mb-24 bg-primary py-20">
    <Container>
      <div class="flex flex-col items-center">
        <h1
          class="text-center font-heading text-7xl font-black uppercase text-secondary"
        >
          Registreer je account
        </h1>

        <div class="mt-20 flex flex-col gap-12 px-6 sm:w-[70%] sm:flex-row">
          <div
            class="flex grow basis-1/2 flex-col items-center rounded-3xl bg-white p-6 sm:p-8"
          >
            <figure
              class="flex w-full items-center justify-center rounded-lg bg-gray-50 py-5"
            >
              <img
                class="h-[124px] w-[124px]"
                src="/images/illustration-personality.svg"
                alt=""
              />
            </figure>
            <div class="mt-8 flex grow flex-col justify-between">
              <h2
                class="px-1 text-center font-heading text-4xl font-black text-secondary uppercase"
              >
                Voor professionals
              </h2>

              <Button
                theme="accent"
                text="Registreer als professional"
                size="md"
                :path="{ name: 'register-professional-general' }"
                class="mt-6 w-full text-center"
              />
            </div>
          </div>

          <div
            class="flex grow basis-1/2 flex-col items-center rounded-3xl bg-white p-8"
          >
            <figure
              class="flex w-full items-center justify-center rounded-lg bg-gray-50 py-5"
            >
              <BaseLogoH
                class="h-[124px] w-[124px] overflow-hidden rounded-full bg-primary object-cover p-2 text-secondary"
              />
            </figure>
            <div class="mt-8 flex grow flex-col justify-between">
              <h2
                class="px-1 text-center font-heading text-4xl font-black text-secondary uppercase"
              >
                Voor bedrijven
              </h2>
              <Button
                theme="accent"
                text="Registreer als bedrijf"
                size="md"
                :path="{ name: 'register-company' }"
                class="mt-6 w-full text-center"
              />
            </div>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>
